import React from 'react';
import { FloatingLabelInput } from '../common/FloatingLabelInput';

interface LocationGroupProps {
  city: string;
  setCity: (value: string) => void;
  cityStatus: 'default' | 'focus' | 'error' | 'success';
  cityFocused: boolean;
  setCityFocused: (v: boolean) => void;
  state: string;
  setState: (value: string) => void;
  stateStatus: 'default' | 'focus' | 'error' | 'success';
  stateFocused: boolean;
  setStateFocused: (v: boolean) => void;
}

const LocationGroup: React.FC<LocationGroupProps> = ({
  city,
  setCity,
  cityStatus,
  setCityFocused,
  state,
  setState,
  stateStatus,
  setStateFocused,
}) => (
  <div className="mb-4 space-y-1">
    <div className="mb-2 text-sm text-gray-400">Enter your location</div>
    <div className="mb-6 grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-4">
      <FloatingLabelInput
        label="City"
        value={city}
        onChange={e => setCity(e.target.value)}
        required
        status={cityStatus}
        onFocus={() => setCityFocused(true)}
        onBlur={() => setCityFocused(false)}
        className="mt-0 md:mt-0"
      />
      <FloatingLabelInput
        label="State"
        value={state}
        onChange={e => setState(e.target.value)}
        required
        status={stateStatus}
        onFocus={() => setStateFocused(true)}
        onBlur={() => setStateFocused(false)}
        className="mt-2 md:mt-0"
      />
    </div>
  </div>
);

export default LocationGroup;
